const options = {
  5: "bg-zinc-900/5",
  10: "bg-zinc-900/10",
  25: "bg-zinc-900/25",
  50: "bg-zinc-900/50",
  75: "bg-zinc-900/75",
  90: "bg-zinc-900/90",
  100: "bg-zinc-900",
};

const from = {
  5: "from-zinc-900/5",
  10: "from-zinc-900/10",
  25: "from-zinc-900/25",
  50: "from-zinc-900/50",
  75: "from-zinc-900/75",
  90: "from-zinc-900/90",
  100: "from-zinc-900",
};

export default function getBackgroundZinc900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
